import React from 'react';

interface Props {
    title?: string;
    content?: string;
    prevContentSeq?: number;
    nextContentSeq?: number;
    prevTitle?: string;
    nextTitle?: string;
    handleGoList: () => void;
    handleGoDetail: (contentSeq: number | undefined) => void;
}

const ColumnView: React.FC<Props> = ({
    title,
    content,
    prevContentSeq,
    nextContentSeq,
    prevTitle,
    nextTitle,
    handleGoList,
    handleGoDetail,
}) => {
    return (
        <div className="mobileface infolist">
            <p className="green f18 lh24 mb30 bold">“매월 검증된 전문 심리 상담사의 칼럼을 확인해보세요."</p>
            <div id="subtab" className="mt20 answer">
                <div className="clear">
                    <a href="#" onClick={handleGoList} className="m white blist black rightBox">목록보기</a>
                </div>
                <div className="conTitle">
                    <h3>{title}</h3>
                </div>
                {
                    content? (
                        <div className="dbCall" dangerouslySetInnerHTML={{__html: content}}></div>
                    ): (
                        <div className="dbCall"></div>
                    )
                }
                <div className="clear">
                    <a href="#" onClick={handleGoList} className="m white blist black rightBox">목록보기</a>
                </div>
                <ul className="view_list mt10">
                    <li className="prev"><strong>다음글</strong>
                        {
                            prevContentSeq === 0? (
                                <a href="#">다음 게시글이 없습니다.</a>
                            ): (
                                <a href="#" onClick={() => handleGoDetail(prevContentSeq)}>{prevTitle}</a>
                            )
                        }
                    </li>
                    <li className="next"><strong>이전글</strong>
                        {
                            nextContentSeq === 0 ? (
                                <a href="#">이전 게시글이 없습니다.</a>
                            ) : (
                                <a href="#" onClick={() => handleGoDetail(nextContentSeq)}>{nextTitle}</a>
                            )
                        }
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default ColumnView;